const ITEMS = [
  {
    n: "05",
    big: "5",
    label: "Años de trayectoria",
    sub: "Operando en logística local desde 2020.",
  },
  {
    n: "10",
    big: "+10.000",
    label: "Pallets movilizados",
    sub: "Compra y venta directa con la industria.",
  },
  {
    n: "01",
    big: "<1h",
    label: "Entrega Ágil",
    sub: "Respuesta a cotizaciones corporativas.",
  },
];

export default function EfficiencyBar() {
  return (
    <section
      data-testid="efficiency-bar"
      className="bg-vp-navy-deep border-b-2 border-vp-yellow"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-0 grid grid-cols-1 md:grid-cols-3">
        {ITEMS.map((it, i) => (
          <div
            key={it.label}
            className={`px-8 py-10 lg:py-14 ${
              i < ITEMS.length - 1 ? "md:border-r-2 border-white/15" : ""
            } border-b-2 md:border-b-0 border-white/15 last:border-b-0 group hover:bg-vp-navy-soft transition-colors`}
          >
            <div className="flex items-start justify-between mb-6">
              <span className="label-industrial">{it.n}</span>
              <div className="w-8 h-[2px] bg-vp-red mt-2" />
            </div>
            <div className="heading-industrial text-6xl lg:text-7xl text-white group-hover:text-vp-yellow transition-colors">
              {it.big}
            </div>
            <div className="mt-4 font-bold uppercase tracking-wide text-white">
              {it.label}
            </div>
            <p className="mt-2 text-white/65 text-sm">{it.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
